/**
 * @file        src/pages/enquiry/EnquiryDetailModal.jsx
 * @description "View" for a Query List row — the list column truncates a long
 *              message to a couple of lines, so this shows the full enquiry
 *              (customer details + untruncated message) from the row the list
 *              already loaded, costing no extra request.
 * @author      Kinetika Labs
 * @created     2026-08-06
 * @changelog
 *   - 2026-08-06 Claude — Initial.
 */
import Chip from '../../components/Chip';
import Icon from '../../components/Icon';

function Row({ label, children }) {
  return (
    <div>
      <span className="muted">{label}</span>
      <div>{children ?? <span className="muted">—</span>}</div>
    </div>
  );
}

function fmtDate(s) {
  if (!s) return '—';
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(s);
  return d.toLocaleString('en-IN', {
    hour: '2-digit', minute: '2-digit', hour12: true,
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export default function EnquiryDetailModal({ enquiry: e, onClose }) {
  if (!e) return null;

  return (
    <div className="lk-overlay" onMouseDown={(ev) => ev.target === ev.currentTarget && onClose()}>
      <div className="lk-modal panel glass" style={{ maxWidth: 640, width: '96%' }}>
        <div className="lk-modal-head">
          <h3>Enquiry #{e.id}</h3>
          <button className="btn xs ghost" onClick={onClose}><Icon name="x" /> Close</button>
        </div>

        <div className="det-body">
          <h4>Customer</h4>
          <div className="det-grid">
            <Row label="Name">{e.name}</Row>
            <Row label="Email">{e.email}</Row>
            <Row label="Phone">{e.phone}</Row>
            <Row label="Brand"><span className="mono">{(e.brand || '—').toUpperCase()}</span></Row>
          </div>

          <h4>Enquiry</h4>
          <div className="det-grid">
            <Row label="Source">{e.source === 'package' ? (e.package_name || 'Package') : 'Contact form'}</Row>
            <Row label="Received">{fmtDate(e.created_at)}</Row>
            <Row label="Status"><Chip tone={e.is_read ? 'ok' : 'warn'}>{e.is_read ? 'Read' : 'Unread'}</Chip></Row>
          </div>

          <h4>Message</h4>
          <p className="mono" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{e.message}</p>
        </div>
      </div>
    </div>
  );
}
